import { EnumTargetType } from 'pages/LoyaltyVoucher/component/Form'
import {
  SET_BENEFITS,
  SET_DETAIL_VOUCHER,
  SET_IS_LOADING,
  SET_LAST_QUERY,
  SET_MECHANISMS,
  SET_PAGINATION_DATA_VOUCHER,
  SET_PAYMENT_CHANNEL,
  SET_RESET,
  SET_TARGETS,
  SET_VOUCHER_DATA,
} from 'storeContext/actionsType/voucher'

interface VoucherTargetType {
  name: string
  [key: string]: unknown
}

interface VoucherPaymentChannelResponseType {
  payment_channel_code: string
  payment_channel_id: string | number
  payment_channel_image_url: string
  payment_channel_name: string
  [key: string]: unknown
}

export interface VoucherPaymentChannelType {
  code: string
  value: string | number
  image: string
  name: string
}

export interface VoucherListItemType {
  voucher_id: string | number
  voucher_code?: string
  voucher_created_at?: string
  benefit_type?: string
  targeting_type?: string
  voucher_status?: string
  voucher_amount?: string | number
  voucher_created_by?: string
  coin_amount?: number
  voucher_active?: boolean
  [key: string]: unknown
}

export interface VoucherPaginationType {
  pageSize?: number
  totalData?: number
  totalPage?: number
  currentPage?: number
  currentItem?: number
}

export interface VoucherDetailType {
  voucher_id?: string | number
  [key: string]: unknown
}

export interface VoucherStateType {
  isLoading: boolean
  isLoadingPaymentChannel: boolean
  data: VoucherListItemType[]
  paginationData: VoucherPaginationType
  lastQuery: Record<string, unknown>
  benefits: unknown[]
  targets: VoucherTargetType[]
  paymentChannelList: VoucherPaymentChannelType[]
  mechanisms: unknown[]
  detail: VoucherDetailType
}

interface VoucherActionType {
  type: string
  payload?: unknown
}

export const initialStateVoucher: VoucherStateType = {
  isLoading: false,
  isLoadingPaymentChannel: false,
  data: [],
  paginationData: {},
  lastQuery: {},
  benefits: [],
  targets: [],
  paymentChannelList: [],
  mechanisms: [],
  detail: {},
}

export default function voucher(
  state = initialStateVoucher,
  { type, payload }: VoucherActionType,
): VoucherStateType {
  switch (type) {
    case SET_IS_LOADING:
      return {
        ...state,
        isLoading: payload as boolean,
      }
    case SET_PAGINATION_DATA_VOUCHER:
      return {
        ...state,
        paginationData: payload as VoucherPaginationType,
      }
    case SET_VOUCHER_DATA:
      return {
        ...state,
        data: payload as VoucherListItemType[],
      }
    case SET_LAST_QUERY:
      return {
        ...state,
        lastQuery: payload as Record<string, unknown>,
      }
    case SET_MECHANISMS:
      return {
        ...state,
        mechanisms: payload as unknown[],
      }
    case SET_TARGETS:
      return {
        ...state,
        targets: (payload as VoucherTargetType[]).filter(
          (i) => i.name === EnumTargetType.globalUser,
        ),
      }
    case SET_PAYMENT_CHANNEL: {
      const newPaymentList = (payload as VoucherPaymentChannelResponseType[]).map(
        (paymentData) => ({
          code: paymentData.payment_channel_code,
          value: paymentData.payment_channel_id,
          image: paymentData.payment_channel_image_url,
          name: paymentData.payment_channel_name,
        }),
      )
      return {
        ...state,
        paymentChannelList: newPaymentList,
      }
    }
    case SET_BENEFITS:
      return {
        ...state,
        benefits: payload as unknown[],
      }
    case SET_DETAIL_VOUCHER:
      return {
        ...state,
        detail: payload as VoucherDetailType,
      }
    case SET_RESET:
      return { ...state, detail: {} }
    default:
      return state
  }
}
